import { breakpoints, spacing } from '@naf/theme';
import { Text } from '@naf/text';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { colors } from '@naf-simba/theme';
import { isNotTransientProp } from '../../../../lib/shouldForwardProp';

export const ChartWrapper = styled.figure<{ $asTable?: boolean }>`
  margin: 0;
  width: 100%;

  ${({ $asTable }) =>
    $asTable
      ? css`
          @media (max-width: ${breakpoints.m}) {
            overflow-x: auto;
          }
        `
      : null};
`;

export const Heading = styled(Text, { shouldForwardProp: isNotTransientProp })<{ $asTable?: boolean }>`
  margin: 0 0 ${({ $asTable }) => ($asTable ? `0 !important` : spacing.space4)};
`;

export const Ingress = styled(Text, { shouldForwardProp: isNotTransientProp })<{ $asTable?: boolean }>`
  margin: ${({ $asTable }) => ($asTable ? '12px 0 0 !important' : `0 0 ${spacing.space4}`)};
`;

export const Caption = styled(Text, { shouldForwardProp: isNotTransientProp })<{ $asTable?: boolean }>`
  font-style: italic;
  margin-top: ${({ $asTable }) => ($asTable ? `${spacing.space32} !important` : '0')};
  margin-bottom: 0;
`;

export const TableWrapper = styled.div`
  background-color: ${colors.secondary[900]};
  padding: ${spacing.space24} ${spacing.space24} 0 ${spacing.space24};

  h2,
  p {
    color: white;
  }
`;
